import script from "./TaskStatusTransitionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaskStatusTransitionModal.vue?vue&type=script&setup=true&lang=ts"

import "./TaskStatusTransitionModal.vue?vue&type=style&index=0&id=3ccb3ffc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ccb3ffc"]])

export default __exports__